const checkItems = [
  "やめようと決意しても、夜になるとまた食べてしまう",
  "帰り道にコンビニへ寄ると、ついお菓子や甘いものを買ってしまう",
  "食べた後に「もうやめよう」と後悔する",
  "間食制限アプリや食事記録を試したけれど、結局続かなかった",
  "自分は意志が弱いのかもしれない、と責めてしまう",
];

export default function EmpathySection() {
  return (
    <section className="relative py-20 px-6 overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/70796dbdcebf9bf2e406fdcc1915fbdd.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        {/* 暗いオーバーレイ */}
        <div className="absolute inset-0 bg-black/72"></div>
      </div>

      {/* コンテンツ */}
      <div className="relative z-10 max-w-2xl mx-auto">
        {/* バッジ */}
        <div className="flex justify-center mb-8">
          <span className="inline-block bg-[#E07040] text-white text-sm font-bold px-5 py-2 rounded-full tracking-wide">
            あなただけじゃありません
          </span>
        </div>

        {/* タイトル */}
        <h2 className="text-2xl md:text-3xl font-black text-white text-center leading-tight mb-12">
          お菓子やジャンクフード、<br className="md:hidden" />甘いものをやめたいのに、<br />
          <span className="text-[#F5A46A]">こんなことありませんか？</span>
        </h2>

        {/* チェックリスト */}
        <div className="space-y-5 mb-12">
          {checkItems.map((item, i) => (
            <div key={i} className="flex items-start gap-4">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="block w-3 h-3 rounded-full bg-[#E07040]"></span>
              </div>
              <p className="text-white text-base md:text-lg leading-relaxed">{item}</p>
            </div>
          ))}
        </div>

        {/* 結論 */}
        <div className="border border-white/30 rounded-2xl p-7 bg-black/60 backdrop-blur-md text-center">
          <p className="text-white/80 text-sm mb-2">でも、それは</p>
          <p className="text-white text-xl md:text-2xl font-black">
            <span className="text-[#66E066]">あなたの意志が弱いからではありません。</span>
          </p>
          <p className="text-white/90 text-base mt-4 leading-relaxed">
            お菓子やジャンクフードが<br className="sm:hidden" />続いてしまうのは、<br />
            <strong className="text-white">
              夜に買えてしまう<br className="sm:hidden" />環境が残っているからです。
            </strong>
          </p>
        </div>
      </div>
    </section>
  );
}
